// src/utils/prettyStationName.js

function applyGermanDiacritics(s) {
  if (!s) return '';
  let out = s.replace(/ss/g, 'ß');
  out = out
    .replace(/ae/g, 'ä')
    .replace(/oe/g, 'ö')
    .replace(/ue/g, 'ü');
  return out;
}

function titleCaseDe(s) {
  return s
    .split(' ')
    .map((part) =>
      part
        .split('-')
        .map((seg) => (seg ? seg.charAt(0).toUpperCase() + seg.slice(1) : seg))
        .join('-')
    )
    .join(' ');
}

const LOWER_WORDS = new Set([
  'am', 'im', 'an', 'auf', 'bei', 'vom', 'zum', 'zur', 'und',
  'der', 'die', 'das', 'von', 'in', 'zu', 'mit', 'für', 'ohne',
  'um', 'beim',
]);

const FIXES = new Map([
  ['Wien Schönbrunn', 'Wien Schönbrunn'],
]);

export function prettyStationName(ortRaw) {
  if (!ortRaw) return '';

  let s = String(ortRaw)
    .trim()
    .replace(/[_]+/g, '-')
    .replace(/-+/g, '-');

  s = s.replace(/-/g, ' ').toLowerCase();
  s = applyGermanDiacritics(s);
  s = titleCaseDe(s);

  s = s
    .split(' ')
    .map((w, i) =>
      i > 0 && LOWER_WORDS.has(w.toLowerCase()) ? w.toLowerCase() : w
    )
    .join(' ');

  if (FIXES.has(s)) {
    s = FIXES.get(s);
  }

  return s;
}
